var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcAlert12X14 = function SvgIcAlert12X14(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d4d4f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_add_alert_24px",
    className: "cls-1",
    d: "M7.673,14.673a1.327,1.327,0,1,0,2.653,0Zm5.913-2.793V8A4.582,4.582,0,0,0,10.06,3.54V3.06a1.06,1.06,0,0,0-2.12,0v.48A4.582,4.582,0,0,0,4.413,8v3.88L3,13.293V14H15v-.707Z",
    transform: "translate(-3 -2)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcAlert12X14);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_alert_12x14.755a30787d62f98204548219d652adb3.svg";